export const PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT =
  'cantilever:component-artifacts:edit'
export const PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT =
  'cantilever:markup-layer:edit'
export const PERMISSION_GECKO_READ = 'gecko:read'
export const PERMISSION_GECKO_INTERNAL_MEMBER = 'gecko:internal:member'
export const PERMISSION_LIBRA_EXECUTIVE = 'libra-executive'
export const PERMISSION_MODUS = 'modus'
export const PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR =
  'cantilever:publisher-archive:editor'
export const PERMISSION_CANTILEVER_ACCESS_ADMIN = 'cantilever:access:admin'
export const PERMISSION_CANTILEVER_CORE_EDIT = 'cantilever:core:edit'
export const PERMISSION_CANTILEVER_CORE_ADMIN = 'cantilever:core:admin'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER =
  'cantilever:asset-overview:viewer'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR =
  'cantilever:asset-overview:editor'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN =
  'cantilever:asset-overview:admin'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER =
  'cantilever:inspection-overview:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR =
  'cantilever:inspection-overview:editor'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN =
  'cantilever:inspection-overview:admin'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER =
  'cantilever:inventory-management:viewer'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR =
  'cantilever:inventory-management:editor'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN =
  'cantilever:inventory-management:admin'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR =
  'cantilever:health-plan:editor'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER =
  'cantilever:health-plan:viewer'
export const PERMISSION_CANTILEVER_BUDGETING_EDITOR =
  'cantilever:budgeting:editor'
export const PERMISSION_CANTILEVER_BUDGETING_VIEWER =
  'cantilever:budgeting:viewer'
export const PERMISSION_CANTILEVER_EXPLORER_EDITOR =
  'cantilever:explorer:editor'
export const PERMISSION_CANTILEVER_EXPLORER_VIEWER =
  'cantilever:explorer:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR =
  'cantilever:inspection-scheduling:editor'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER =
  'cantilever:inspection-scheduling:viewer'
export const PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR =
  'cantilever:parts-thread:editor'
export const PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER =
  'cantilever:parts-thread:viewer'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR =
  'cantilever:photogrammetry:editor'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN =
  'cantilever:photogrammetry:admin'
export const PERMISSION_CANTILEVER_PUBLISHER_VIEWER =
  'cantilever:publisher:viewer'
export const PERMISSION_CANTILEVER_PUBLISHER_EDITOR =
  'cantilever:publisher:editor'
export const PERMISSION_CANTILEVER_PUBLISHER_ADMIN =
  'cantilever:publisher:admin'

export const PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR =
  'cantilever:extension-configuration:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR =
  'cantilever:process-flow:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER =
  'cantilever:process-flow:viewer'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN =
  'cantilever:process-flow:admin'

export const PERMISSION_CANTILEVER_DELPHI_VIEWER = 'cantilever:delphi:viewer'
export const PERMISSION_CANTILEVER_TIME_SERIES_EDITOR =
  'cantilever:time-series:editor'

export const PERMISSION_CANTILEVER_SYSTEM_VIEWER =
  'cantilever:system-view:viewer'

export const PERMISSION_CANTILEVER_POSTS_VIEWER = 'cantilever:posts:viewer'
export const PERMISSION_CANTILEVER_POSTS_EDITOR = 'cantilever:posts:editor'
export const PERMISSION_CANTILEVER_VALUE_STORY_ADMIN =
  'cantilever:value-story:admin'

export const PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER =
  'cantilever:matterport-walkthrough:viewer'

export const PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR =
  'cantilever:anomaly-detection:editor'

export const PERMISSION_CANTILEVER_CASES_EDITOR = 'cantilever:cases:editor'
export const PERMISSION_CANTILEVER_CASES_VIEWER = 'cantilever:cases:viewer'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER =
  'cantilever:power-document-navigator:viewer'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR =
  'cantilever:power-document-navigator:editor'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN =
  'cantilever:power-document-navigator:admin'
export const PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER =
  'cantilever:navy-production-dashboard:viewer'
export const PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR =
  'cantilever:navy-production-dashboard:editor'
export const PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER =
  'cantilever:virtual-reports:viewer'
export const PERMISSION_NII_EDITOR = 'nii-editor'
export const PERMISSION_CANTILEVER_CHAT_USER = 'cantilever:chat:user'
export const PERMISSION_CANTILEVER_DOC_CHAT_VIEWER = 'cantilever:doc-chat:viewer'
// List of all permission values for UI components (e.g., dropdowns)
// TODO: Remember to add new permissions here when creating them above
export const ALL_STATIC_PERMISSION_VALUES = [
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  PERMISSION_GECKO_READ,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_LIBRA_EXECUTIVE,
  PERMISSION_MODUS,
  PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR,
  PERMISSION_CANTILEVER_ACCESS_ADMIN,
  PERMISSION_CANTILEVER_CORE_EDIT,
  PERMISSION_CANTILEVER_CORE_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN,
  PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
  PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
  PERMISSION_CANTILEVER_BUDGETING_EDITOR,
  PERMISSION_CANTILEVER_BUDGETING_VIEWER,
  PERMISSION_CANTILEVER_EXPLORER_EDITOR,
  PERMISSION_CANTILEVER_EXPLORER_VIEWER,
  PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR,
  PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER,
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
  PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR,
  PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN,
  PERMISSION_CANTILEVER_PUBLISHER_VIEWER,
  PERMISSION_CANTILEVER_PUBLISHER_EDITOR,
  PERMISSION_CANTILEVER_PUBLISHER_ADMIN,
  PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR,
  PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR,
  PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER,
  PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN,
  PERMISSION_CANTILEVER_DELPHI_VIEWER,
  PERMISSION_CANTILEVER_TIME_SERIES_EDITOR,
  PERMISSION_CANTILEVER_SYSTEM_VIEWER,
  PERMISSION_CANTILEVER_POSTS_VIEWER,
  PERMISSION_CANTILEVER_POSTS_EDITOR,
  PERMISSION_CANTILEVER_VALUE_STORY_ADMIN,
  PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER,
  PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR,
  PERMISSION_CANTILEVER_CASES_EDITOR,
  PERMISSION_CANTILEVER_CASES_VIEWER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER,
  PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR,
  PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER,
  PERMISSION_NII_EDITOR,
  PERMISSION_CANTILEVER_CHAT_USER,
  PERMISSION_CANTILEVER_DOC_CHAT_VIEWER,
] as const

// External user permissions
type SiteEditPermission = `rolodex:site:${string}:edit`
type SiteEditorPermission = `rolodex:site:${string}:editor`
type SiteMemberPermission = `rolodex:site:${string}:member`
type OrgMemberPermission = `rolodex:organization:${string}:member`
type OrgEditPermission = `rolodex:organization:${string}:edit`
type OrgAdminPermission = `rolodex:organization:${string}:admin`

// Libra ticket-group scoped permissions
type LibraTicketGroupAdminPermission =
  `cantilever:libra-ticket-group:${string}:admin`
type LibraTicketGroupEditorPermission =
  `cantilever:libra-ticket-group:${string}:editor`
type LibraTicketGroupReviewerPermission =
  `cantilever:libra-ticket-group:${string}:reviewer`

export function getSiteEditPermission(siteId: string): SiteEditPermission {
  return `rolodex:site:${siteId}:edit`
}

export function getSiteEditorPermission(siteId: string): SiteEditorPermission {
  return `rolodex:site:${siteId}:editor`
}

export function getSiteMemberPermission(siteId: string): SiteMemberPermission {
  return `rolodex:site:${siteId}:member`
}
export function getOrgMemberPermission(orgId: string): OrgMemberPermission {
  return `rolodex:organization:${orgId}:member`
}

export function getOrgEditPermission(orgId: string): OrgEditPermission {
  return `rolodex:organization:${orgId}:edit`
}

export function getOrgAdminPermission(orgId: string): OrgAdminPermission {
  return `rolodex:organization:${orgId}:admin`
}

export function getLibraTicketGroupAdminPermission(
  groupId: string
): LibraTicketGroupAdminPermission {
  return `cantilever:libra-ticket-group:${groupId}:admin`
}

export function getLibraTicketGroupEditorPermission(
  groupId: string
): LibraTicketGroupEditorPermission {
  return `cantilever:libra-ticket-group:${groupId}:editor`
}

export function getLibraTicketGroupReviewerPermission(
  groupId: string
): LibraTicketGroupReviewerPermission {
  return `cantilever:libra-ticket-group:${groupId}:reviewer`
}

export const geckoPerms = [
  PERMISSION_CANTILEVER_ACCESS_ADMIN,
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_CORE_EDIT,
  PERMISSION_GECKO_READ,
  PERMISSION_GECKO_INTERNAL_MEMBER,
]

export type RolodexPermissionsValues =
  | typeof PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT
  | typeof PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT
  | typeof PERMISSION_GECKO_READ
  | typeof PERMISSION_GECKO_INTERNAL_MEMBER
  | typeof PERMISSION_LIBRA_EXECUTIVE
  | typeof PERMISSION_MODUS
  | typeof PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR
  | typeof PERMISSION_CANTILEVER_ACCESS_ADMIN
  | typeof PERMISSION_CANTILEVER_CORE_EDIT
  | typeof PERMISSION_CANTILEVER_CORE_ADMIN
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER
  | typeof PERMISSION_CANTILEVER_BUDGETING_EDITOR
  | typeof PERMISSION_CANTILEVER_BUDGETING_VIEWER
  | typeof PERMISSION_CANTILEVER_EXPLORER_EDITOR
  | typeof PERMISSION_CANTILEVER_EXPLORER_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER
  | typeof PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN
  | typeof PERMISSION_CANTILEVER_PUBLISHER_VIEWER
  | typeof PERMISSION_CANTILEVER_PUBLISHER_EDITOR
  | typeof PERMISSION_CANTILEVER_PUBLISHER_ADMIN
  | SiteEditPermission
  | SiteEditorPermission
  | SiteMemberPermission
  | OrgMemberPermission
  | OrgEditPermission
  | OrgAdminPermission
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN
  | typeof PERMISSION_CANTILEVER_DELPHI_VIEWER
  | typeof PERMISSION_CANTILEVER_TIME_SERIES_EDITOR
  | typeof PERMISSION_CANTILEVER_SYSTEM_VIEWER
  | typeof PERMISSION_CANTILEVER_POSTS_VIEWER
  | typeof PERMISSION_CANTILEVER_POSTS_EDITOR
  | typeof PERMISSION_CANTILEVER_VALUE_STORY_ADMIN
  | typeof PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER
  | typeof PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR
  | typeof PERMISSION_CANTILEVER_CASES_EDITOR
  | typeof PERMISSION_CANTILEVER_CASES_VIEWER
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN
  | typeof PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER
  | typeof PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR
  | typeof PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER
  | typeof PERMISSION_NII_EDITOR
  | typeof PERMISSION_CANTILEVER_CHAT_USER
  | typeof PERMISSION_CANTILEVER_DOC_CHAT_VIEWER
  | LibraTicketGroupAdminPermission
  | LibraTicketGroupEditorPermission
  | LibraTicketGroupReviewerPermission
